import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapType } from "../../../../hooks/map.type";
import ListRobotMapPage from "../list-robot-map";
import ListLayoutMapPage from "../list-layout-map";
import BindRobotMapScreen from "../../quick-setup/bind-robot-map";
import { parseAsArrayOf, parseAsString, useQueryState } from "nuqs";

export default function CreateBindLayoutMapPage({
  onSubmit,
  onCancel
}: {
  onSubmit?: () => void,
  onCancel?: () => void
}) {
  const navigate = useNavigate()
  const [step, setStep] = useState(1)
  const [selectedRobotId, setSelectedRobotId] = useQueryState('robot_map_uuid', parseAsArrayOf(parseAsString, ';'))
  const [selectedLayoutId, setSelectedLayoutId] = useQueryState('layout_map_uuid', parseAsArrayOf(parseAsString, ';'))
  const [selectedRobotMaps, setSelectedRobotMaps] = useState<MapType[]>([])
  const [selectedLayoutMaps, setSelectedLayoutMaps] = useState<MapType[]>([])

  useEffect(() => {
    if (!selectedRobotId) {
      return
    }
    if (selectedLayoutId && selectedRobotId.length > 0 && selectedLayoutId?.length > 0) {
      setStep(3)
      return
    }
    if (selectedRobotId.length > 0) {
      setStep(2)
    }
  }, [selectedRobotId])

  const onSubmitRobotMaps = (robotMaps: MapType[]) => {
    if (!robotMaps || robotMaps.length === 0) {
      return
    }
    setSelectedRobotMaps(robotMaps)
    setSelectedRobotId(robotMaps.map((r) => r.map_uuid))
    setStep(2)
  }

  const onSubmitLayoutMaps = (layoutMaps: MapType[]) => {
    if (!layoutMaps || layoutMaps.length === 0) {
      return
    }
    setSelectedLayoutMaps(layoutMaps)
    setSelectedLayoutId(layoutMaps.map((r) => r.map_uuid))
    setStep(3)
  }

  const handleCancel = () => {
    if (onCancel !== undefined) {
      onCancel()
      return
    }
    navigate('/config/bind-layout-maps', {
      replace: true,
    })
  }
  return (
    <Box>
      {step === 1 && (
        <ListRobotMapPage showForBind onCancel={() => handleCancel()} onSubmit={(val) => onSubmitRobotMaps(val)} />
      )}
      {step === 2 && (
        <ListLayoutMapPage
          onSubmit={(val) => onSubmitLayoutMaps((val))}
          showBack
          showCancel
          onBack={() => {
            setStep(1)
          }}
          onCancel={() => handleCancel()}
        />
      )}
      {step === 3 && (
        <BindRobotMapScreen
          selectedMapsUUID={selectedLayoutId || []}
          selectedRobotMapsUUID={selectedRobotId || []}
          showBack
          showCancel
          onBack={() => {
            setStep(2)
          }}
          onCancel={() => handleCancel()}
          nextLabel="Submit"
          onSubmit={(val) => {
            setSelectedRobotId([])
            setSelectedLayoutId([])
            if (onSubmit !== undefined) {
              onSubmit()
              return
            }
            navigate('/config/bind-layout-maps', {
              replace: true,
            })
          }}
        />
      )}
    </Box>
  )
}